(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["m-bonus"] && !Shopify.designMode) return;
  try {
    
(function(){
  var REV = '2024-10-15';
  function call(path, company, body){
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'revision': REV},
      body: JSON.stringify(body)
    }).then(function(r){ if(!r.ok) throw new Error('Klaviyo ' + r.status); });
  }
  function reportLead(f){
    if(f.__mWuLead) return;
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      if(!p || !p.marketingAllowed){ f.setAttribute('data-lead-status', 'privacy-unavailable'); return; }
      if(!p.marketingAllowed()){ f.setAttribute('data-lead-status', 'consent-not-granted'); return; }
      if(typeof window.fbq !== 'function'){ f.setAttribute('data-lead-status', 'pixel-unavailable'); return; }
      var id = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
      window.fbq('trackSingle', '993171590459504', 'Lead', {}, {eventID: 'mentalin-wu-' + id});
      f.__mWuLead = true;
      f.setAttribute('data-lead-status', 'sent');
    } catch(err) { f.setAttribute('data-lead-status', 'error'); }
  }
  function bind(f){
    if(f.__mWu) return; f.__mWu = true;
    var msg = f.querySelector('[data-m-wu-msg]'), btn = f.querySelector('button[type=submit]');
    function say(t){ if(msg) msg.textContent = t; }
    f.addEventListener('submit', function(e){
      e.preventDefault();
      if(btn.disabled) return;
      if(f.elements.website && f.elements.website.value) return;
      if(!f.checkValidity()){ f.reportValidity(); return; }
      var metric = f.getAttribute('data-metric'), company = f.getAttribute('data-company');
      if(!metric){ say('Diese Anmeldung ist noch nicht freigeschaltet. Bitte versuche es später noch einmal.'); return; }
      var email = f.elements.email.value.trim();
      var profile = {data: {type: 'profile', attributes: {email: email}}};
      var calls = [call('events', company, {data: {type: 'event', attributes: {
        profile: profile,
        metric: {data: {type: 'metric', attributes: {name: metric}}},
        properties: {source: 'waking-up-section', page: location.pathname},
        time: new Date().toISOString()
      }}}).then(function(){ reportLead(f); })];
      var list = f.getAttribute('data-list');
      if(list && f.elements.newsletter && f.elements.newsletter.checked){
        calls.push(call('subscriptions', company, {data: {type: 'subscription', attributes: {
          profile: profile, custom_source: 'Waking-Up-Section (freiwillig)'
        }, relationships: {list: {data: {type: 'list', id: list}}}}}));
      }
      btn.disabled = true; say('Einen Moment …');
      Promise.all(calls).then(function(){
        say(f.getAttribute('data-success') || 'Danke! Wir schicken dir deinen Gutschein per E-Mail.');
        f.querySelector('.m-footer__form').hidden = true;
      }).catch(function(){
        btn.disabled = false;
        say('Das hat leider nicht geklappt. Bitte versuche es noch einmal.');
      });
    });
  }
  function init(){ document.querySelectorAll('[data-m-wu-form]').forEach(bind); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m-contact"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function init(){
    document.querySelectorAll('form[data-m-contact]').forEach(function(f){
      if(f.dataset.mReady) return; f.dataset.mReady = '1';
      f.addEventListener('submit', function(e){
        var hp = f.querySelector('[data-m-hp]');
        if(hp && hp.value){ e.preventDefault(); e.stopImmediatePropagation(); }
      }, true);
    });
    var st = document.querySelector('[data-m-contact-state]');
    if(st){ st.scrollIntoView({block: 'center'}); st.focus({preventScroll: true}); }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m-faq-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function setup(root){
    if(root.dataset.mFaqExtra) return; root.dataset.mFaqExtra = '1';
    var out = root.querySelector('[data-m-faq-count]'), input = root.querySelector('[data-m-faq-search]');
    function count(){
      if(!out) return;
      var q = input ? input.value.trim() : '';
      var all = root.querySelector('[data-m-faq-cat="all"][aria-pressed="true"]');
      if(!q && all){ out.textContent = ''; return; }
      var n = root.querySelectorAll('[data-faq-item]:not([hidden])').length;
      var tpl = n === 1 ? out.getAttribute('data-one') : out.getAttribute('data-many');
      out.textContent = (tpl || '').replace('[n]', n);
    }
    root.addEventListener('input', function(){ setTimeout(count, 0); });
    root.addEventListener('click', function(e){
      if(e.target.closest('[data-m-faq-cat]')) setTimeout(count, 0);
      if(e.target.closest('[data-m-faq-reset]')){
        if(input){ input.value = ''; input.dispatchEvent(new Event('input', {bubbles: true})); }
        var allChip = root.querySelector('[data-m-faq-cat="all"]'); if(allChip) allChip.click();
        if(input) input.focus();
      }
    });
    function openHash(){
      var h = location.hash; if(!h || h.length < 2) return;
      var t = null; try { t = root.querySelector(h); } catch(err) { return; }
      if(t && t.tagName === 'DETAILS'){ t.open = true; }
    }
    window.addEventListener('hashchange', openHash);
  }
  function init(){ document.querySelectorAll('[data-m-faq]').forEach(setup); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m-footer"]) return;
  try {
    
(function(){
  var REV = '2024-10-15';
  function bind(f){
    if(f.__mFk) return; f.__mFk = true;
    var msg = f.querySelector('[data-m-footer-msg]'), btn = f.querySelector('button[type=submit]');
    function say(t, err){ if(msg){ msg.textContent = t; msg.setAttribute('role', err ? 'alert' : 'status'); } }
    f.addEventListener('submit', function(e){
      e.preventDefault();
      if(f.elements.website && f.elements.website.value) return;
      var email = (f.elements.email.value || '').trim();
      if(!f.checkValidity() || !email){ say('Bitte prüfe deine E-Mail-Adresse.', true); f.elements.email.focus({preventScroll:true}); return; }
      var attrs = {email: email};
      var first = (f.elements.first_name.value || '').trim();
      if(first) attrs.first_name = first;
      btn.disabled = true; say('Einen Moment …');
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(f.getAttribute('data-company')), {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'revision': REV},
        body: JSON.stringify({data: {type: 'subscription', attributes: {
          profile: {data: {type: 'profile', attributes: attrs}},
          custom_source: 'Footer-Newsletter'
        }, relationships: {list: {data: {type: 'list', id: f.getAttribute('data-list')}}}}})
      }).then(function(r){
        if(!r.ok) throw new Error('Klaviyo ' + r.status);
        say(f.getAttribute('data-success') || 'Fast geschafft! Bitte bestätige deine Anmeldung über den Link in unserer E-Mail.');
        var ttl = f.getAttribute('data-success-title');
        if(msg && ttl){
          var h = document.createElement('strong'); h.className = 'm-footer__msg-title'; h.textContent = ttl;
          msg.insertBefore(h, msg.firstChild); msg.classList.add('m-footer__msg--success');
        }
        var row = f.querySelector('.m-footer__form'); if(row) row.hidden = true;
      }).catch(function(){
        btn.disabled = false;
        say('Die Anmeldung hat nicht geklappt. Bitte versuche es erneut.', true);
      });
    });
  }
  function init(){ document.querySelectorAll('[data-m-footer-klaviyo]').forEach(bind); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m-studies"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready) return; root.dataset.ready = '1';
    var per = parseInt(root.dataset.per || '4', 10);
    if(window.innerWidth < 750) per = Math.min(per, 2);
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-m-studies-group]'));
    var chipsWrap = root.querySelector('[data-m-studies-chips]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-m-studies-filter]'));
    var status = root.querySelector('[data-m-studies-status]');
    function setExpanded(g, open){
      var items = g.querySelectorAll('[data-m-study]'), btn = g.querySelector('[data-m-studies-more]');
      if(!btn) return;
      for(var i = per; i < items.length; i++){ items[i].hidden = !open; }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    }
    groups.forEach(function(g){
      var btn = g.querySelector('[data-m-studies-more]');
      var all = g.querySelectorAll('[data-m-study]');
      if(!btn){
        if(all.length > per){
          btn = document.createElement('button'); btn.type = 'button'; btn.className = 'm-btn m-btn--secondary m-btn--sm m-studies__more'; btn.setAttribute('data-m-studies-more', '');
          btn.dataset.more = (all.length - per) === 1 ? '1 weitere Studie anzeigen' : 'Weitere ' + (all.length - per) + ' Studien anzeigen'; btn.dataset.less = 'Weniger anzeigen';
          all[all.length - 1].parentNode.appendChild(btn);
        } else { return; }
      } else {
        var rest = all.length - per; btn.dataset.more = rest === 1 ? '1 weitere Studie anzeigen' : btn.dataset.more.replace(/\d+/, String(rest));
      }
      btn.hidden = false; setExpanded(g, false);
      btn.addEventListener('click', function(){
        var open = btn.getAttribute('aria-expanded') !== 'true';
        setExpanded(g, open);
        if(open){ var items = g.querySelectorAll('[data-m-study]'); if(items[per]) items[per].querySelector('summary').focus(); }
      });
    });
    function filter(k){
      chips.forEach(function(c){ c.setAttribute('aria-pressed', c.dataset.mStudiesFilter === k ? 'true' : 'false'); if(c.dataset.mStudiesFilter === k && status) status.textContent = c.dataset.status || ''; });
      groups.forEach(function(g){ g.hidden = !(k === 'all' || g.dataset.mStudiesGroup === k); });
    }
    if(chipsWrap){ chipsWrap.hidden = false; }
    chips.forEach(function(c){ c.addEventListener('click', function(){ filter(c.dataset.mStudiesFilter); }); });
    function fromHash(){
      var id; try{ id = decodeURIComponent(location.hash.slice(1)); }catch(e){ return; }
      if(!id) return;
      var t = document.getElementById(id); if(!t || !root.contains(t)) return;
      var g = t.matches('[data-m-studies-group]') ? t : t.closest('[data-m-studies-group]'); if(!g) return;
      if(g.hidden) filter('all');
      if(t === g){ setExpanded(g, true); }
      else if(t.matches('[data-m-study]')){ if(t.hidden) setExpanded(g, true); t.open = true; setTimeout(function(){ t.scrollIntoView({block:'start'}); }, 40); }
    }
    fromHash(); window.addEventListener('hashchange', fromHash);
    root.addEventListener('click', function(e){
      var a = e.target.closest('a[href^="#studie-"]'); if(!a) return;
      setTimeout(fromHash, 0);
    });
  }
  function boot(){ Array.prototype.forEach.call(document.querySelectorAll('[data-m-studies]'), init); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
